import React from "react";
import * as slideStyles from "./HeroBannerSlide.module.scss";
import * as styles from "./HeroBannerUrgentMessageSlide.module.scss";
import {
  BlockContentValue,
  SectionContainer
} from "@silversea-ssc/ui-components-react";
import { BlockContent } from "components/BlockContent";

interface HeroBannerUrgentMessageSlideProps {
  sliderControls: JSX.Element;
  content: BlockContentValue;
}

const HeroBannerUrgentMessageSlide: React.FC<
  React.PropsWithChildren<HeroBannerUrgentMessageSlideProps>
> = ({ sliderControls, content }) => {
  return (
    <div className={slideStyles.slide}>
      <div className={styles.slideBackgroundSolid}></div>

      <React.Fragment>
        <SectionContainer
          className={slideStyles.contentContainer}
          wrapperClassName={slideStyles.contentContainerWrapper}
          backgroundColor="transparent"
        >
          <div className={styles.topContent}>
            <div className={styles.title}>
              <BlockContent value={content} />
            </div>
          </div>
          {sliderControls}
        </SectionContainer>
      </React.Fragment>
    </div>
  );
};

export default React.memo(HeroBannerUrgentMessageSlide);
